import { find } from 'lodash';
import { FC, Suspense } from 'react';
import { useParams } from 'react-router';
import { ErrorBoundary } from '~/components';
import { OutboundSubscriptionManager } from '~/components/atoms/subscription-manager';
import { SuspenseLoader } from '~/components/molecules/suspense-loader';
import { Features } from '../features';
import { General } from '../general';
import { ProjectAdminMenuItem, ProjectAdminMenuType } from '../list/types';
import { ProjectAdminMenuItems } from '../list/utils';
import { ProjectAdmin } from '../project-admin';
import { Sync } from '../sync';
import { ToolRooms } from '../tool-rooms';
import { UserAdmin } from '../user-admin';
import { ProjectAdminDetailContainerStyled } from './styled';
import { ProjectAdminDetailProps } from './types';

export const ProjectAdminDetail: FC<ProjectAdminDetailProps> = ({ isListCollapsed }) => {
  const { id } = useParams();
  const menuItem = find(ProjectAdminMenuItems(), (item: ProjectAdminMenuItem) => {
    return item.value == id;
  });

  return (
    <ProjectAdminDetailContainerStyled isListCollapsed={isListCollapsed}>
      {menuItem && menuItem.type === ProjectAdminMenuType.USER_ADMIN && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <UserAdmin />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.TOOLROOMS && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <ToolRooms />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.SYNC && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <OutboundSubscriptionManager />
            <Sync />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.GENERAL && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <General />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.FEATURES && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <Features />
          </Suspense>
        </ErrorBoundary>
      )}
      {menuItem && menuItem.type === ProjectAdminMenuType.PROJECT_ADMIN && (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <ProjectAdmin />
          </Suspense>
        </ErrorBoundary>
      )}
    </ProjectAdminDetailContainerStyled>
  );
};
